/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Comment } from './Comment';
import {
    CommentFromJSON,
    CommentFromJSONTyped,
    CommentToJSON,
} from './Comment';

/**
 * 
 * @export
 * @interface CommentResponse
 */
export interface CommentResponse {
    /**
     * 
     * @type {Array<Comment>}
     * @memberof CommentResponse
     */
    data?: Array<Comment>;
}

/**
 * Check if a given object implements the CommentResponse interface.
 */
export function instanceOfCommentResponse(value: object): value is CommentResponse {
    let isInstance = true;

    return isInstance;
}

export function CommentResponseFromJSON(json: any): CommentResponse {
    return CommentResponseFromJSONTyped(json, false);
}

export function CommentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CommentFromJSON)),
    };
}

export function CommentResponseToJSON(value?: CommentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CommentToJSON)),
    };
}

